import React from "react"
import { graphql } from "gatsby"
import { Link } from "gatsby"
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Text } from "../../Text/Text"


interface OwnProps {
  currentPage: string;
  locationsSubPath?: boolean;
}

export type BreadcrumbProps = OwnProps

export const Breadcrumb: React.FC<BreadcrumbProps> = ({
  currentPage,
  locationsSubPath
}) => {
  const { t } = useTranslation("shared", {
    keyPrefix: "location_pages.breadcrumb",
  });

  return (
    <>
      <Link to="/">
        <span className="underline">
          <Text as="span" variant="body">{t("home")}</Text>
        </span>
      </Link>
      {locationsSubPath && (
        <>
          <Text as="span" variant="body"> / </Text>
          <Link to="/plasma-donation/location/">
            <span className="underline">
              <Text as="span" variant="body">{t("locations")}</Text>
            </span>
          </Link>
        </>
      )}
      <Text as="span" variant="body">
        <span className="no-underline"> / {currentPage}</span>
      </Text>
    </>
  )
}
